import React, { useEffect } from 'react';
import { navigate } from 'gatsby';

const Shop = () => {
  useEffect(() => {
    // Redirect to homepage
    navigate('/');
  }, []);

  return null;
};

export default Shop;
